import { configureStore } from "@reduxjs/toolkit";
import shallowCompare from "common/utils/shallowCompare";
import { useDispatch, useSelector } from "react-redux";
import { planLibraryReducer } from "./planLibraryReducer";
import type { PlanLibraryInitializedState } from "./planLibraryTypes";

export function planLibraryConfigureStore() {
  return configureStore({
    middleware: (fn) => fn({ immutableCheck: false, serializableCheck: false }),
    reducer: planLibraryReducer,
  });
}

export const planLibraryStore = planLibraryConfigureStore();

export function usePlanLibrarySelector<T extends object>(
  selector: (state: PlanLibraryInitializedState) => T,
  compare: (left: T, right: T) => boolean = shallowCompare,
) {
  return useSelector(selector, compare);
}

export const usePlanLibraryDispatch: () => typeof planLibraryStore.dispatch = useDispatch;
